import { Star, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/lang";

const Testimonials = () => {
  const { t } = useLang();
  const items = t.testimonials?.items || [];
  const badges = t.testimonials?.badges || [];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] font-mono text-amber-700/90 mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-amber-500/60 inline-block" />
            {t.testimonials?.eyebrow}
          </p>
          <h2 data-testid="testimonials-title" className="font-serif text-2xl sm:text-3xl lg:text-5xl tracking-tight text-ivory max-w-2xl leading-[1.1]">
            {t.testimonials?.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((item, i) => (
            <Reveal key={i} delay={0.12 * i}>
              <article
                data-testid={`testimonial-card-${i}`}
                className="h-full bg-surface border border-amber-500/15 hover:border-amber-400/50 rounded-lg p-8 flex flex-col gap-6 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(0,0,0,0.5)] transition-all duration-500"
              >
                <div className="flex gap-1 text-champagne">
                  {[...Array(5)].map((_, s) => <Star key={s} size={14} fill="currentColor" strokeWidth={0} />)}
                </div>
                <blockquote className="font-serif italic text-lg leading-relaxed text-zinc-600 flex-1">“{item.quote}”</blockquote>
                <div>
                  <div className="text-sm font-semibold text-ivory">{item.name}</div>
                  <div className="text-xs text-zinc-500 mt-1">{item.role}</div>
                  <div className="flex items-center gap-1.5 mt-3 text-[10px] uppercase tracking-[0.15em] text-champagne/80">
                    <BadgeCheck size={12} /> {badges[i]}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
